<app-page padding="0">

    <div style="width: 100%; height: 50vh;" >
      <div class="row flex">

      <div  *ngIf="isCheckingElaborazione()" class="flex flex-column align-items-center justify-content-center h-full p-1 gap-1 lg:gap-3 text-700">
        <div class="flex flex-column md:flex-row align-items-center justify-content-between gap-1 lg:gap-3">
          <div *ngIf="isCheckingElaborazione()" class="flex"><span>Il file è stato trasmesso ai server di AnTeA. <br> Attendi il completamento del salvataggio sul database</span><mat-spinner style="transform: scale(0.3);bottom:35px"></mat-spinner></div>
        </div>
      </div>
      <div class="col-4">
        <div style="text-align: right;">
          <app-button *ngIf="createPermission"  icon="add" [fullWidth]="false"  label="Aggiungi coordinate" (click)="openModalAdd()"></app-button>
        </div>
        <br>
        <app-card title="Elenco File Caricati">
          @for (file of selectedFile(); track file.name; let i = $index) {
            <div style="display:flex">
              <p >{{file?.name!}}</p>
              <app-button  (click)="deleteFeature(file?.customFeatureId, i )"  [fullWidth]="false"  icon="cancel" label="" />
            </div>
          }
        </app-card>
        <br>
        <app-card title="Metadati">
          <app-input-text [form]="insertForm" name="nome" label="nome"></app-input-text>
        </app-card>
      </div>
      
        <div class="col-8">
          <google-map 
          height="500px" 
          width="100%" 
          [center]="center" 
          [zoom]="zoom" 
          [options]="options">
        </google-map>
        </div>
  
    </div> 
    </div>
   


 

   <div footer class="text-center"  *ngIf="!showData">
    <div>
      <div class="p-2 flex flex-end w-full" style="justify-content: end;">
        <app-button *ngIf="createPermission" (click)="onSendClick()" [disabled]="!insertForm.valid"  [fullWidth]="false"  icon="send" label="Trasmetti" raised/>
      </div>
    </div>
  </div> 
  <div footer class="text-center"  *ngIf="showData">
    <div>
      <div class="p-2 flex flex-end w-full" style="justify-content: end;">
        <app-button  *ngIf="createPermission" (click)="onSendWszGeojsonClick()" [disabled]="!insertForm.valid"  [fullWidth]="false"  icon="send" label="Salva" raised/>
      </div>
    </div>
  </div>
</app-page>

